import script from "./AbilitiesRadarCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbilitiesRadarCard.vue?vue&type=script&setup=true&lang=ts"

import "./AbilitiesRadarCard.vue?vue&type=style&index=0&id=47cd6b8e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cd6b8e"]])

export default __exports__